// redux/calendar_ICS/constants.js

export const FETCH_ICS_REQUEST = 'FETCH_ICS_REQUEST';
export const FETCH_ICS_SUCCESS = 'FETCH_ICS_SUCCESS';
export const FETCH_ICS_FAILURE = 'FETCH_ICS_FAILURE';
